module.exports = __webpack_public_path__ + "static/media/fixed-voice-minus.754c0a2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed-voice-minus.svg
// module id = 988
// module chunks = 0